module.exports = __webpack_public_path__ + "static/media/header-delicias.6dd953aa.png";